import { render, staticRenderFns } from "./wbbgCommon.vue?vue&type=template&id=3c1a81a2&scoped=true&"
import script from "./wbbgCommon.vue?vue&type=script&lang=js&"
export * from "./wbbgCommon.vue?vue&type=script&lang=js&"
import style0 from "./wbbgCommon.vue?vue&type=style&index=0&id=3c1a81a2&scoped=true&lang=scss&"
import style1 from "./wbbgCommon.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1a81a2",
  null
  
)

export default component.exports